import { Metrics } from '../../constants/Dashboards'
import type { ActionsTypes, ApiCallType } from '../types'

type MetricActionType = Record<string, ApiCallType>

const prefix: string = 'DASHBOARD'
const postfixRequest: string = 'REQUEST'
const postfixSuccess: string = 'SUCCESS'
const postfixFailure: string = 'FAILURE'
const statusLink: string = '##'
const actionTypeLink: string = '_'

function generateActionTypeMetric(metric: Metrics): MetricActionType {
    const fixedMetric: string = metric.toUpperCase().replace(/-/g, actionTypeLink)
    const globalActionType: string = [prefix, fixedMetric].join(actionTypeLink)

    const buildActionType = (status: string): string => {
        return [globalActionType, status].join(statusLink)
    }

    const statusMap: Record<string, string> = {
        request: postfixRequest,
        success: postfixSuccess,
        failure: postfixFailure,
    }

    return {
        [globalActionType]: Object.keys(statusMap).reduce(
            (carry, status: string): ApiCallType => {
                return {
                    ...carry,
                    [status]: buildActionType(statusMap[status as string]),
                }
            },
            {
                request: '',
                success: '',
                failure: '',
            }
        ),
    }
}

export default function generateActionType(metrics: Metrics[]): ActionsTypes {
    return metrics.reduce((carry, metric: Metrics) => {
        return {
            ...carry,
            ...generateActionTypeMetric(metric),
        }
    }, {})
}
